export const css = {
    groupRoot: 'u7BV4jWY',
    column: '_1ANvGi4D',
    fieldRoot: '_1Yt6UCf-',
    ' _key': 'certwise-theme/dojo/form'
};
export default css;
